import React from "react";
import "./App.css";

function App() {
  // WhatsApp number
  const whatsappNumber = process.env.REACT_APP_WHATSAPP_NUMBER;
  const whatsappLink = `https://wa.me/${whatsappNumber}`;
  const whatsappIdLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
    "Hi, I want an ID"
  )}`;

  const features = [
    { text: "10 Lakh+ Active Users", icon: "👥" },
    { text: "Instant Transfer", icon: "⚡" },
    { text: "10% Real Rewards on First Deposit", icon: "🎁" },
    { text: "100+ Free Games", icon: "🎮" },
    { text: "Deposit ₹1000 above and get ₹200 bonus", icon: "💰" },
  ];

  return (
    <div className="landing-root">
      {/* Header with logo */}
      <div className="landing-header">
        <img
          src={`/premio.png`}
          alt="PREMIO99 Logo"
          className="logo"
        />
        <h2 className="logo-title">PREMIO99</h2>
      </div>

      {/* Main content */}
      <div className="landing-content">
        <h1>Welcome to PREMIO99!</h1>
        <p>
          Don’t miss out — chat with us now on WhatsApp and grab your deal before
          it’s gone.
        </p>

        <a
          href={whatsappLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta"
        >
          <img
            src={`/wp.png`}
            alt="WhatsApp"
            className="btn-icon"
          />
          Continue to Chat
        </a>

        <a
          href={whatsappIdLink}
          target="_blank"
          rel="noopener noreferrer"
          className="btn-cta-id"
        >
          <img
            src={`/wp.png`}
            alt="WhatsApp"
            className="btn-icon"
          />
          Get your 🆔

        </a>


        {/* Features Section */}
        <div className="features">
          {features.map((f, i) => (
            <div className="feature-card" key={i}>
              <span className="feature-icon">{f.icon}</span>
              <span className="feature-text">{f.text}</span>
            </div>
          ))}
        </div>


      </div>

      {/* Footer fixed at bottom */}
      <div className="landing-footer">
        By tapping the button you agree to connect with us on WhatsApp.
      </div>
    </div>
  );
}

export default App;
